module.exports = __webpack_public_path__ + "img/Picture3.7fc4a8e6.png";